// extracted by mini-css-extract-plugin
module.exports = {"section":"EarningStatistic-section_8fbfd12b","title":"EarningStatistic-title_0705a509","tip":"EarningStatistic-tip_0ac087bb","tipContent":"EarningStatistic-tipContent_3ff35ec4"};